import React from "react";
import { motion } from "framer-motion";

const BloodSugarGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">روند روزانه</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 flex items-end shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    {[...Array(24)].map((_, i) => {
                        const height = 20 + Math.sin(i / 3) * 15 + Math.random() * 10;
                        const color = height > 50 ? "bg-[#FF4F00]" : height < 30 ? "bg-[#0072CE]" : "bg-[#32D74B]";
                        return (
                            <motion.div
                                key={i}
                                className={`w-1.5 mx-0.5 rounded-t-[4px] ${color}`}
                                initial={{ height: 0 }}
                                animate={{ height: `${height}%` }}
                                transition={{
                                    duration: 0.2,
                                    delay: i * 0.03,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                        );
                    })}
                </div>
            </div>

            <div className="flex justify-between text-xs text-[#9EA3A9]">
                <span>صبحانه</span>
                <span>ناهار</span>
                <span>شام</span>
            </div>
        </div>
    );
};

export default BloodSugarGraph;
